var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Stack } from '@mui/material';
import React from 'react';
import { ReactComponent as CloseIcon } from '../../../assets/images/close.svg';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
var AddPDIQuestionMobileView = function (_ref) {
    var data = _ref.data, onClose = _ref.onClose;
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: '16px 0px',
            columnSize: 12,
            spacing: 0,
            justifyContent: 'space-between',
            alignItems: 'center',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'Enter question',
                    columnSize: 0,
                    fontSize: 'xl',
                    fontWeight: 'strong'
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "secondary[600]",
                        height: '20px',
                        width: '20px'
                    }),
                    columnSize: 0,
                    onClick: function () {
                        onClose();
                    }
                }]
        }, {
            type: FormItemTypes.TextInput,
            name: 'QuestionName',
            label: 'Question name',
            columnSize: 12,
            required: true
        }, {
            type: FormItemTypes.TextInput,
            name: 'InspectionCriteria',
            label: 'Inspection criteria',
            columnSize: 12,
            required: true
        }, {
            type: FormItemTypes.TextInput,
            name: 'IssueDescription',
            label: 'SOP',
            columnSize: 12,
            required: true
        }, {
            type: FormItemTypes.Box,
            name: '',
            display: 'flex',
            columnSize: 12,
            position: 'fixed',
            bottom: 0,
            right: 0,
            bgcolor: 'white',
            p: 2,
            width: '100%',
            justifyContent: 'end',
            sx: {
                borderTop: '1px solid ',
                borderColor: '#DEE4EB',
                gap: '16px'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Cancel',
                    columnSize: 6,
                    fullWidth: true,
                    color: 'primary',
                    variant: 'outlined',
                    onClick: function () {
                        onClose();
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Add',
                    columnSize: 6,
                    fullWidth: true,
                    color: 'primary',
                    variant: 'contained',
                    onClick: function () { return 'submit'; },
                    setFieldProps: function (formValues, currValue, field) {
                        console.log('Question Name:', formValues);
                        var isDisabled = (!(formValues !== null && formValues !== void 0 && formValues.InspectionCriteria1) || (formValues === null || formValues === void 0 ? void 0 : formValues.InspectionCriteria1) === '') && (!(formValues !== null && formValues !== void 0 && formValues.InspectionCriteria2) || (formValues === null || formValues === void 0 ? void 0 : formValues.InspectionCriteria2) === '') && (!(formValues !== null && formValues !== void 0 && formValues.IssueDescription) || (formValues === null || formValues === void 0 ? void 0 : formValues.IssueDescription) === '');
                        return {
                            type: FormItemTypes.Button,
                            disabled: isDisabled ? true : undefined
                        };
                    }
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Stack, {
        p: 2,
        height: "999px"
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        updateFormAPI: function (_ref2) { return __awaiter(void 0, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                request = _ref2.request;
                onClose(request);
                return [2 /*return*/, {
                        success: true
                    }];
            });
        }); }
    })));
};
export default AddPDIQuestionMobileView;
